import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';


const Wrapper = ({title, loading, titleControls, location, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}/>
      <Notice
        display={location && location.archived}
        message={[
          'This location has been archived and is therefore no longer available.',
          'You won\'t be able to modify it unless it is restored.'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['location']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Stock', link: routes.stock.index},
  {title: 'Locations', link: reverse(routes.stock.index, {tab: 'locations'})}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)},
  {title: 'Locations', link: reverse(routes.archive.index, {tab: 'locations'})}
];

export default Wrapper;
